// @ts-nocheck
// import { DEFAULT_ROUTE_CONFIG } from './defaultRoutesConfig';
import { getLabelPathFromLabelConfig } from '../utils/Utils';
import Store from '../store/Store';
import { ReactComponent as Connectivity } from '../assets/images/Reports/Connectivity.svg';
import { ReactComponent as Activity } from '../assets/images/Reports/Activity.svg';
import { ReactComponent as KRIReport } from '../assets/images/Reports/KRIReport.svg';
import { ReactComponent as ModelReport } from '../assets/images/Reports/ModelReport.svg';
import { ReactComponent as PowerBI } from '../assets/images/Reports/PowerBI.svg';
import { ReactComponent as Attribute } from '../assets/images/Reports/Attribute.svg';

export const DEFAULT_TABLE_SCHEMA_CONFIG = {
  showToolbar: true, // If you want to show the toolbar then set this to true
  readOnly: false, // If you want to view whole table in read only mode then set this to true
  editMode: false, // If you want to handle the behaviors like edit cell but do not want to show the add column rows buttons, set this to true
  showCellPreviewer: true, // If you want to show the cell previewer then set this to true
  fromConstAttributeFeature: false, // If the TableSchemaBuilder is being used from Constant Attribute feature then we need to handle some specific behaviors like disabling some actions, etc.
  configColumn: false, // If enabled, columns act as attribute selectors instead of generic grid columns
};

// Data types that cannot be selected as column attributes in config column mode
export const RESTRICTED_DATA_TYPES_FOR_CONFIG_COLUMN = [
  'AdvancedTable',
  'Table',
  'Chart',
  'Segments',
  'FieldChange',
  'Checklist',
  'Association',
  'Paragraph',
];

const VALUE_EQUAL = { label: 'equal', value: 'equal' };
const VALUE_NOT_EQUAL = { label: 'not equal', value: 'ne' };
const VALUE_GREATER_THAN_EQUAL = { label: 'greater than equal', value: 'gte' };
const VALUE_LESS_THAN_EQUAL = { label: 'less than equal', value: 'lte' };
const VALUE_LESS_THAN = { label: 'less than', value: 'lt' };
const VALUE_GREATER_THAN = { label: 'greater than', value: 'gt' };
const VALUE_CONTAINS = { label: 'contains', value: 'contains' };

// Date only (month/day/year) --> Output: 08/17/2025
export let DATE_FORMAT = localStorage.getItem('dateFormat') || 'MM/DD/YYYY';

// Date only (day/month/year) --> Output: 17/08/2025
export const DD_MM_YYYY_DATE_FORMAT = 'DD/MM/YYYY';

// Date with 24-hour time (hours & minutes) --> Output: 08/17/2025, 18:45
export let DATE_FORMAT_HH_MM = `${DATE_FORMAT}, HH:mm`;

// Date with 24-hour time (hours, minutes & seconds) --> Output: 08/17/2025, 18:45:14
export let DATE_FORMAT_HH_MM_SS = `${DATE_FORMAT}, HH:mm:ss`;

/**
 * Updates DATE_FORMAT and derived formats after the backend value is fetched.
 * Called from Layout.fetchTenantPlugins once the API response is available.
 * @param {string} newFormat - e.g. 'DD/MM/YYYY'
 */
export const updateDateFormats = (newFormat) => {
  DATE_FORMAT = newFormat || 'MM/DD/YYYY';
  DATE_FORMAT_HH_MM = `${DATE_FORMAT}, HH:mm`;
  DATE_FORMAT_HH_MM_SS = `${DATE_FORMAT}, HH:mm:ss`;
};

// ISO-style date format (used in APIs payloads) --> Output: 2025-08-17
export const YYYY_MM_DD_DATE_FORMAT = 'YYYY-MM-DD';

// Human-readable full date with 24-hour time --> Output: 17th August 2025, 21:45
export const DO_MMMM_YYYY_DATE_FORMAT_HH_MM = 'Do MMMM YYYY, HH:mm';

// Human-readable full date --> Output: 17th Aug 2025
export const DO_MMM_YYYY_DATE_FORMAT = 'Do MMM YYYY';

export const RELATION_OPTIONS = [
  { label: 'Related to', value: 'Related to' },
  { label: 'Duplicate to', value: 'Duplicate to' },
  { label: 'Parent to', value: 'Parent to' },
];

export const CARDINALITY_OPTIONS = [
  { label: 'One to One', value: 'one-to-one' },
  { label: 'One to Many', value: 'one-to-many' },
  { label: 'Many to Many', value: 'many-to-many' },
];

export const EVENT_RELATIONS = [
  { label: 'Up stream', value: 'UpStream' },
  { label: 'Down stream', value: 'DownStream' },
];

export const ENTITY_TYPES = [
  {
    label: 'ModelInventory',
    value: 'ModelInventory',
    pluginKey: 'hide_ModelInventory',
  },
  {
    label: 'ModelAssociation',
    value: 'ModelAssociation',
    pluginKey: 'hide_ModelAssociation',
  },
  {
    label: 'Assessment',
    value: 'ModelRequest',
    pluginKey: 'hide_ModelRequest',
  },
  { label: 'Use Case', value: 'UseCase', pluginKey: 'hide_useCase' },
  {
    label: 'Access Request',
    value: 'AccessRequest',
    pluginKey: 'hide_AccessRequest',
  },
  { label: 'Query', value: 'Query', pluginKey: 'hide_query' },
];

/**
 * Filters ENTITY_TYPES based on pluginConfig from Redux store.
 * Entries with a pluginKey are excluded when pluginConfig[pluginKey] is true.
 * @returns {Array} filtered entity types
 */
export const getFilteredEntityTypes = () => {
  const pluginConfig = Store?.getState()?.tenant?.pluginConfig || {};
  return ENTITY_TYPES?.filter(
    (type) => !type?.pluginKey || !pluginConfig?.[type?.pluginKey]
  );
};

export const RELATIONS = [
  { label: 'Custom Relation', value: 'custom_relation' },
  { label: 'Itself', value: 'itself' },
];

export const ENTITY_TYPE = {
  ModelInventory: 'ModelInventory',
  ModelAssociation: 'ModelAssociation',
  ModelRequest: 'ModelRequest',
  AccessRequest: 'accessRequest',
  UseCase: 'UseCase',
  workflows: 'workflows',
  Query: 'Query',
};

export const ENTITY_TYPE_LABELS = {
  ModelInventory: 'My Models',
  ModelAssociation: 'Model Artifact',
  ModelRequest: 'Assessment',
  AccessRequest: 'Access Request',
  UseCase: 'Use Case',
  workflows: 'workflows',
};

export const FILTER_SECTION_WIDTH = '650px';
export const ITEM_HEIGHT_FOR_VIRTUALIZATION = 30;

export const PRIORITIES = [
  { label: 'High', value: 'High' },
  { label: 'Medium', value: 'Medium' },
  { label: 'Low', value: 'Low' },
];

//single select multi select
export const SELECT_TYPES = [
  { label: 'SINGLE SELECT', value: 'Single Select' },
  { label: 'MULTI SELECT', value: 'Multi Select' },
  { label: 'CHECKLIST', value: 'Checklist' },
  { label: 'ADVANCED TABLE', value: 'AdvancedTable' },
];

export const DATA_TYPES = [
  { label: 'Text', value: 'Character' },
  { label: 'HTML', value: 'HTML' },
  { label: 'Paragraph', value: 'Paragraph' },
  { label: 'Date', value: 'Date' },
  { label: 'Integer', value: 'Integer' },
  { label: 'Float', value: 'Decimal' },
  { label: 'Chart', value: 'Chart' },
  { label: 'Table', value: 'Table' },
  { label: 'User', value: 'User' },
  { label: 'Group', value: 'Group' },
  { label: 'Entity List', value: 'Association' },
  { label: 'Hyperlink', value: 'Hyperlink' },
  { label: 'Segments', value: 'Segments' },
  { label: 'FieldChange', value: 'FieldChange' },
  { label: 'Attribute List', value: 'AttributeList' },
  { label: 'Parameter Table List', value: 'ParameterTableList' },
  { label: 'Email Template List', value: 'EmailTemplateList' },
  { label: 'Template List', value: 'TemplateList' },
  { label: 'FieldChange Actions', value: 'FieldChangeActions' },
  { label: 'IssueType', value: 'IssueType' },
  { label: 'Inventory View', value: 'InventoryView' },
];

export const HISTORY_ICON_EXCLUDED_DATA_TYPES = [
  'AdvancedTable',
  'Chart',
  'Association',
  'Document',
  'Segments',
  'FieldChange',
  'Checklist',
  'Table',
  'IssueType',
  'HTML',
];

export const CONSTANT_ATTRIBUTE_DATA_TYPES = [
  {
    label: 'DataFrame',
    value: 'DataFrame',
  },
  { label: 'Integer', value: 'Integer' },
  { label: 'Float', value: 'Decimal' },
  { label: 'Text', value: 'Text' },
];

export const FREQUENCIES = [
  { label: 'Yearly', value: 'Yearly' },
  { label: 'Quarterly', value: 'Quarterly' },
  { label: 'Monthly', value: 'Monthly' },
];

export const DEFAULT_TEXT_MAX_LENGTH_FALLBACK = 200;

export const INPUT_TYPES = [
  { label: 'Single select', value: 'SINGLE_SELECT' },
  { label: 'Multi select', value: 'MULTI_SELECT' },
  { label: 'HTML field', value: 'HTML_FIELD' },
  {
    label: 'Text field',
    value: 'TEXTFIELD',
    metaData: {
      Character: `${DEFAULT_TEXT_MAX_LENGTH_FALLBACK} Char`,
      Date: DATE_FORMAT,
      Hyperlink: `${DEFAULT_TEXT_MAX_LENGTH_FALLBACK} Char`,
    },
  },
  {
    label: 'Text field (extended)',
    value: 'TEXTFIELD_EXTENDED',
    metaData: { Character: '10,000 Char' },
  },
  { label: 'IFrame', value: 'IFRAME' },
  { label: 'Table', value: 'TABLE' },
  { label: 'Document', value: 'DOCUMENT' },
  { label: 'Advanced table', value: 'ADVANCED_TABLE' },
  { label: 'Inventory View', value: 'InventoryView' },
];

export const SHOW_IN_SUMMARY = [
  { label: 'Model Summary', value: 'model_summary' },
  { label: 'Risk Assessment', value: 'risk_assessment' },
  { label: 'Exclude from Summary', value: 'exclude_summary' },
];

export const USER_TYPES = [
  { label: 'Model Developer', value: 'Model Developer' },
  { label: 'Model Validator', value: 'Model Validator' },
];

export const TABLE_HEIGHT_CONSTANTS = {
  HEADER_HEIGHT: 56,
  TITLE_HEIGHT: 50,
  TABS_HEIGHT: 48,
  SEARCH_BAR_HEIGHT: 80,
  PAGINATION_HEIGHT: 60,
  PADDING_AND_MARGINS: 40,
};

export const MODEL_STATIC_FIELDS = [
  'accesslevel',
  'type',
  'assignedUser',
  'model_name',
  'model_id',
  'created_at',
  'updated_at',
  'created_by',
  'updated_by',
  'created_on',
  'updated_on',
  'description',
  'status',
  'modelRiskRating',
  'unique_id',
  'currentVersion',
  'due_date',
  'workflowId',
  'workflowName',
  'priority',
  'entityName',
  'entityType',
  'riskRating',
  'entityId',
  'entityName',
  'saveAs',
  'due_date',
  'description',
  'priority',
  'association_name',
  'relation',
  'assignedTo',
  'additional_property',
  'Status',
  'Workflows',
  'Model Id',
  'Assigned User',
  'Model Name',
];

// Common fields for all the entities, these are hardcoded keys maintained by the backend
export const commonFields = [
  'workflow',
  'assignedUser',
  'type',
  'entity_alias',
  'entity_code',
  'created_at',
  'created_by',
  'updated_at',
  'updated_by',
  'description',
  'status',
  'delegated_by',
];

export const FIXED_REORDER_COLUMN = {
  all: {
    entity_alias: 0,
    entity_code: 1,
    'Model Status': 2,
    'Model Purpose': 3,
    'Business Unit': 4,
    'Model Owner': 5,
    'Model Developer': 6,
    'Model Sponsor': 7,
    'Model Tier': 8,
    'Current Use Approval Status': 9,
    'Date of Independent Validation': 10,
    'Date of Last Annual Review M': 11,
    'Name of Validator Review': 12,
    'Vendor Name': 13,
    'AIML Model': 14,
    Platform: 15,
    'Open Policy Exception Derived': 16,
    'Open Policy Extension Derived': 17,
    'Open Findings Derived': 18,
    ELT: 19,
    'Governance Ownership': 20,
  },
  ai: {
    entity_alias: 0,
    entity_code: 1,
    unique_id: 2,
    'Business Unit': 3,
    'Model Owner': 4,
    'Model Developer': 5,
    'Model Sponsor': 6,
    'Model Tier': 7,
    'Model Status': 8,
    'Final ModelTool  Determination': 9,
    'Model Purpose': 10,
    'AIML Model': 11,
    'Gen AI': 12,
    'Vendor Developed': 13,
    'Vendor Name': 14,
    Platform: 15,
    'Asset ID in CMDB': 16,
    CDO: 17,
    'Bright Idea ID': 18,
  },
  my: {
    entity_alias: 0,
    entity_code: 1,
    'Model Status': 2,
    'Model Purpose': 3,
    'Business Unit': 4,
    'Model Owner': 5,
    'Model Developer': 6,
    'Model Sponsor': 7,
    'Current  Risk   Tier': 8,
    'Current Use Approval Status': 9,
    'Date of Independent Validation': 10,
    'Date of Last Annual Review M': 11,
    'Name of Validator Review': 12,
    'Vendor Name': 13,
    'AIML Model': 14,
    Platform: 15,
    'Open Policy Exception Derived': 16,
    'Open Policy Extension Derived': 17,
    'Open Findings Derived': 18,
    ELT: 19,
    'Governance Ownership': 20,
  },
};

/**
 * Fixed column order (by response key) pinned to the front of the
 * Assessment (ModelRequest) list table.
 * Gated behind `frontendConfig.afi_model_inventory_hardcoded_columns`; the
 * remaining columns follow their template/API order after these.
 */
export const FIXED_REORDER_ASSESSMENT_COLUMN = {
  unique_id: 0,
  entity_alias: 1,
  entity_code: 2,
  status: 3,
  description: 4,
  created_by: 5,
  type: 6,
};

/**
 * Fixed column order (by response key) pinned to the front of the model
 * artifact/association list table inside ModelInventoryAndAssociation.
 * Gated behind `frontendConfig.afi_model_inventory_hardcoded_columns`; these
 * API-driven columns come first, the hardcoded linked-entity columns follow,
 * and the remaining columns keep their template/API order after those.
 */
export const FIXED_REORDER_ASSOCIATION_COLUMN = {
  unique_id: 0,
  entity_alias: 1,
  status: 2,
  created_on: 3,
  created_by: 4,
};

export const CHECKLIST_FIXED_COLUMN = {
  unique_id: 0,
  entity_alias: 1,
  'Business Unit': 2,
  'Model Tier': 3,
  'Model Status': 4,
  'Model in Use by MO': 5,
  'Model Owner': 6,
  'Model Developer': 7,
  'Model Sponsor': 8,
  Platform: 9,
  'AIML Model': 10,
  'Gen AI': 11,
  'Bright Idea ID': 12,
  'Vendor Model': 13,
  'Planned Production Date': 14,
  'Actual Production Date': 15,
  'Model Certification Status': 16,
  'Certification Completion Date': 17,
  'Model Attestation Status': 18,
  'Attestation Completion Date': 19,
};

export const INVALID_REGEX_MESSAGE = 'Incorrect input';
export const CANNOT_START_WITH_NUMBERS_MSG = "Can't start with a number.";
export const SPECIAL_CHAR_NOT_ALLOWED_MSG =
  'Special characters are not allowed.';
export const ONLY_CHARACTERS_ALLOWED = 'Only characters are allowed.';

export const NOT_AUTHORIZED_TO_ACCESS_MESSAGE =
  'You are not authorized to access this!';

export const GENERATE_VALID_WORKFLOW_MESSAGE =
  'Please generate a valid workflow.';

export const MONTH_ORDER_MAP = {
  January: 1,
  February: 2,
  March: 3,
  April: 4,
  May: 5,
  June: 6,
  July: 7,
  August: 8,
  September: 9,
  October: 10,
  November: 11,
  December: 12,
};

export const INTEGRATION_PARTNERS = [{ label: 'Nimbus Uno', value: 'Nimbus' }];

export const ISSUE_TYPE = [
  { label: 'Validation', value: 'validation' },
  { label: 'Monitoring', value: 'monitoring' },
  { label: 'Findings', value: 'finding' },
  { label: 'Other Lifecycle Events', value: 'other_lifecycle_event' },
];

export const MENTIONED_ENTITIES = {
  artifact: {
    mentionType: 'artifact:mention',
    mentionTrigger: ['artifact:'],
    entityMutability: 'IMMUTABLE',
  },
  document: {
    mentionType: 'document:mention',
    mentionTrigger: ['document:'],
    entityMutability: 'IMMUTABLE',
  },
  model: {
    mentionType: 'model:mention',
    mentionTrigger: ['model:'],
    entityMutability: 'IMMUTABLE',
  },
  attribute: {
    mentionType: 'attribute:mention',
    mentionTrigger: ['attribute:'],
    entityMutability: 'IMMUTABLE',
  },
  // This is default behavior of draft js plugin
  user: {
    mentionType: 'mention',
    mentionTrigger: ['@'],
    entityMutability: 'SEGMENTED',
  },
};

export const CONDITIONAL_TRANSITION_LINE_COLORS = [
  'Red',
  'Orange',
  'Yellow',
  'Green',
  'Blue',
  'Indigo',
  'Violet',
];

export const REACTFLOW_NODE_TYPES = {
  WORKFLOW_NODE: 'workflowNode',
  CONDITIONAL_NODE: 'conditionalNode',
};

export const REACTFLOW_NODE_CHOICES = [
  { label: 'User Driven State', value: REACTFLOW_NODE_TYPES.WORKFLOW_NODE },
  { label: 'Automated State', value: REACTFLOW_NODE_TYPES.CONDITIONAL_NODE },
];
// Function to update the choices after initialization
// export const initializeReactFlowNodeChoices = (getLabelPathFromLabelconfig) => {
//   const label = getLabelPathFromLabelconfig(
//     DEFAULT_ROUTE_CONFIG.workflow.keyPath,
//     'featureLabel',
//     'User Driven State'
//   );
//   REACTFLOW_NODE_CHOICES[0].label = `${label} State`;
// };
export const ATTRIBUTE_OPERATORS = {
  Integer: [
    VALUE_EQUAL,
    VALUE_GREATER_THAN_EQUAL,
    VALUE_LESS_THAN_EQUAL,
    VALUE_LESS_THAN,
    VALUE_GREATER_THAN,
    VALUE_NOT_EQUAL,
  ],
  Decimal: [
    VALUE_EQUAL,
    VALUE_GREATER_THAN_EQUAL,
    VALUE_LESS_THAN_EQUAL,
    VALUE_LESS_THAN,
    VALUE_GREATER_THAN,
    VALUE_NOT_EQUAL,
  ],
  Date: [
    VALUE_EQUAL,
    VALUE_GREATER_THAN_EQUAL,
    VALUE_LESS_THAN_EQUAL,
    VALUE_LESS_THAN,
    VALUE_GREATER_THAN,
    VALUE_NOT_EQUAL,
  ],
  Character: [VALUE_EQUAL, VALUE_CONTAINS, VALUE_NOT_EQUAL],
  SingleSelect: [VALUE_EQUAL, VALUE_NOT_EQUAL],
  Choice: [VALUE_EQUAL, VALUE_CONTAINS, VALUE_NOT_EQUAL],
  Text: [VALUE_EQUAL, VALUE_CONTAINS, VALUE_NOT_EQUAL],
  Bool: [VALUE_EQUAL],
};

export const EVENT_FREQUENCY_UNIT_CHOICES = [
  'days',
  'weeks',
  'months',
  'years',
];

export const BULK_UPDATE_RESULT_STEPS = [
  {
    key: 'attribute_update',
    label: 'Attribute Updation',
  },
];

export const BULK_CREATE_RESULT_STEPS = [
  {
    key: 'entity_creation',
    label: 'Entity Creation',
  },
  {
    key: 'model_creation',
    label: 'Model Creation',
  },
  {
    key: 'attribute_creation',
    label: 'Attribute Creation',
  },
  {
    key: 'model_association_creation',
    label: 'Model Association Creation',
  },
];

export const MUST_BE_POSITIVE_NUMBER_MESSAGE = 'Must be greater than 0';

export const BULK_UPDATE_COMMON_ATTRIBUTES = [
  {
    label: 'Assigned User',
    value: 'assignedUser',
  },
  {
    label: 'Entity Name',
    value: 'entity_name',
  },
  {
    label: 'Entity ID',
    value: 'entity_id',
  },
];

export const MODEL_ASSOCIATION_ADDITIONAL_COMMON_ATTRIBUTES = [
  {
    label: 'Severity',
    value: 'priority',
  },
];

export const HAS_REFRESHED_KEY = 'retry-lazy-refreshed';

export const EXAMPLE_CONTENT_DERIVED_FORMULA = [
  {
    title: 'Basic Expression',
    content:
      '{{attributes.AttributeName}} + {{attributes.AnotherAttributeName}}',
  },
  {
    title: 'Mathematical Formula with Division',
    content:
      '({{attributes.risk}} + {{attributes.risk_description}}) - {{attributes.impact}}) / 100',
  },
  {
    title: 'String Concatenation',
    content: '{{attributes.AttributeName}} + "string for concatenation"',
  },
  {
    title: 'Conditional Expression',
    content:
      '{{attributes.attribute_name}} if({{attributes.another_attribute}}>100) else {{attributes.fallback_attribute}}',
  },
  {
    title: 'Lookup Formula (Excel-based rule matching)',
    content:
      'lookup("rule-table", conditions = {"Area (MD/MO)": {{attributes.area}}, "Area MU": {{attributes.mu}}, "Regulatory": {{attributes.regulatory}}, "AIML": {{attributes.aiml}}, "Model Materiality": {{attributes.materiality}}, "MRM Scope": {{attributes.scope}}}, stateColumnsMapping = {"Registration": "Registration Template", "PDV": "PDV Template", "Deployment": "Deployment Template"})',
  },
  {
    title: 'Basic HTML Rendering',
    content: `Derived Formula:
{
    "status":
    "HIGH" if({{attributes.risk_score}} >= 80)
    else "LOW"
}

HTML Template:
<h3>Status : {{status}}</h3>`,
  },
  {
    title: 'Conditional HTML Rendering',
    content: `Derived Formula:
{
    "risk_status":
    "High Risk" if({{attributes.score}} >= 80)
    else "Medium Risk" if({{attributes.score}} >= 50)
    else "Low Risk"
}

HTML Template:
<td>
{% if risk_status == "High Risk" %}
<span style="color:red;">{{risk_status}}</span>

{% elif risk_status == "Medium Risk" %}
<span style="color:orange;">{{risk_status}}</span>

{% else %}
<span style="color:green;">{{risk_status}}</span>
{% endif %}
</td>`,
  },
  {
    title: 'Table Rendering',
    content: `Derived Formula:
result = {
    "headers": ["Model Name", "Workflow Status"],
    "rows": [
        ["{{attributes.model_name}}", "{{attributes.status}}"]
    ]
}

HTML Template:
<table border="1">
<thead>
<tr>
    {% for h in headers %}
        <th>{{ h }}</th>
    {% endfor %}
</tr>
</thead>
<tbody>
{% for row in rows %}
<tr>
    {% for cell in row %}
        <td>{{ cell }}</td>
    {% endfor %}
</tr>
{% endfor %}
</tbody>
</table>`,
  },
  {
    title: 'Filter Based HTML Rendering',
    content: `Saved filters can be used to dynamically fetch and render entity data inside HTML templates.

Derived Formula:
filter_obj = GetFilter(
    filter_name="Risk Tier",
    entity_type="ModelInventory",
    user="mrm_admin"
)

data = filter_obj.get_filter()

headers = ["Model Name", "Workflow Status"]

rows = []

for item in data:
    rows.append([
        item.get("entity_name", ""),
        item.get("status", "")
    ])

result = {
    "headers": headers,
    "rows": rows
}

HTML Template:
<table border="1">
<thead>
<tr>
    {% for h in headers %}
        <th>{{ h }}</th>
    {% endfor %}
</tr>
</thead>
<tbody>
{% for row in rows %}
<tr>
    {% for cell in row %}
        <td>{{ cell }}</td>
    {% endfor %}
</tr>
{% endfor %}
</tbody>
</table>`,
  },
  {
    title: 'InventoryView Attribute Guide',
    content: `An Inventory View formula returns a Python dictionary describing:

The formula must assign the final output to a variable named result.

1. source_template
The template whose records should be displayed.

"source_template": "New Models"

2. filters
A list of attribute values used to filter records.

"filters": [
    {{attributes.MArea}},
    {{attributes.status}}
]

3. point_in_time
Date used to retrieve records as of a specific date (Optional).

"point_in_time": {{attributes.EDate}}

4. columns
List of attributes that should appear as columns in the inventory view.

"columns": [
    {{attributes.entity_alias}},
    {{attributes.unique_id}},
    {{attributes.advance_integer}},
    {{attributes.advance_float}},
    {{attributes.bh}},
]

Complete Example
result = {
    "filters": [{{attributes.MArea}},{{attributes.status}}],
    "point_in_time": {{attributes.EDate}},
    "columns": [
      {{attributes.entity_alias}},
      {{attributes.unique_id}},
      {{attributes.advance_integer}},
      {{attributes.advance_float}},
      {{attributes.bh}},
    ],
    "source_template": "New Models"
}`,
  },
];

/**
 * DOCUMENTATION: Multi-line Tooltip Structure for Derived Formula
 *
 * This section explains how to structure content for the DerivedFormulaTooltip component
 * that supports both single-line and multi-line content with proper formatting.
 *
 * DATA STRUCTURE FORMAT:
 * Each item in the array should have:
 * {
 *   text: [array of strings],     // Each string is rendered as a separate line
 *   bold: [array of strings],     // Words/phrases to be bolded (optional)
 *   italic: [array of strings],   // Words/phrases to be italicized (optional)
 *   id: number                    // Unique identifier
 * }
 *
 * SINGLE LINE CONTENT:
 * For content that should appear on one line, put the entire sentence in one string:
 * text: ['Use double curly braces {{...}} to access attributes directly.']
 *
 * MULTI-LINE CONTENT:
 * For content with multiple lines or bullet points, use separate strings:
 * text: [
 *   'How Lookup Works:',              // Header line
 *   '• System loads the Excel file',   // Bullet point 1
 *   '• Finds the row where all conditions match', // Bullet point 2
 *   '• Returns the cell value'         // Bullet point 3
 * ]
 *
 * FORMATTING RULES:
 * - First array element: Renders inline unless it starts with '•'
 * - Subsequent elements: Render as block (new lines)
 * - Lines starting with '•': Automatically get left margin for indentation
 * - Bold/italic arrays: Specify exact text strings that should be formatted
 * - Bold/italic matching: Case-sensitive and must match exactly
 *
 * EXAMPLES:
 *
 * Single line with bold text:
 * {
 *   text: ['Use double curly braces {{...}} to access attributes directly.'],
 *   bold: ['double curly braces {{...}}'],
 *   id: 1
 * }
 *
 * Multi-line with header and bullets:
 * {
 *   text: [
 *     'How Lookup Works:',
 *     '• System loads the Excel file',
 *     '• Finds the row where all conditions match',
 *     '• Reads the current model stage from entityDetail.status',
 *     '• Picks the template column for that stage',
 *     '• Returns the cell value'
 *   ],
 *   bold: [],  // No bold text in this example
 *   id: 8
 * }
 *
 * Mixed content with formatting:
 * {
 *   text: ['The lookup() function selects values from Excel rule-tables.'],
 *   bold: ['lookup()'],
 *   italic: ['Excel rule-tables'],
 *   id: 6
 * }
 *
 * COMPONENT BEHAVIOR:
 * - Detects bullet points (lines starting with '•') and adds proper indentation
 * - Applies bold/italic formatting by finding matching text within each line
 * - Handles both inline and block display based on content structure
 * - Preserves spacing and line breaks as intended
 *
 * ADDING NEW CONTENT:
 * 1. Decide if content should be single-line or multi-line
 * 2. Structure the text array accordingly
 * 3. Identify any words/phrases that need bold or italic formatting
 * 4. Add exact matching strings to bold/italic arrays
 * 5. Assign a unique ID
 * 6. Test the display in the tooltip component
 */

export const GENERAL_RULES_CONTENT_DERIVED_FORMULA = [
  {
    text: ['Use double curly braces {{...}} to access attributes directly.'],
    bold: ['double curly braces {{...}}'],
    id: 1,
  },
  {
    text: [
      'Attributes can be accessed directly using {{attributes.AttributeName}} without section references.',
    ],
    bold: ['{{attributes.AttributeName}}'],
    id: 2,
  },
];

/**
 * NOTE: This array follows the same multi-line tooltip structure documented above.
 * Refer to the DOCUMENTATION comment before GENERAL_RULES_CONTENT_DERIVED_FORMULA
 * for detailed formatting guidelines and examples.
 */
export const NOTE_CONTENT_DERIVED_FORMULA = [
  {
    text: ['Use double curly braces {{...}} to access attributes directly.'],
    bold: ['double curly braces {{...}}'],
    id: 1,
  },
  {
    text: [
      'Spacing and parentheses are crucial to maintain formula integrity.',
    ],
    bold: [],
    id: 2,
  },
  {
    text: ['For string concatenation, enclose the string in inverted commas.'],
    bold: [],
    id: 3,
  },
  {
    text: [
      'Conditional statements follow the format: value_if_true if condition else value_if_false',
    ],
    italic: ['value_if_true if condition else value_if_false'],
    id: 4,
  },
  {
    text: [
      'Attributes can be accessed directly using {{attributes.AttributeName}} without requiring section or entity prefixes.',
    ],
    bold: ['{{attributes.AttributeName}}'],
    id: 5,
  },
  {
    text: [
      'The lookup() function selects a value from an Excel rule-table by matching multiple attributes with Excel rows.',
    ],
    bold: ['lookup()'],
    id: 6,
  },
  {
    text: [
      'Lookup syntax: lookup("constant-attribute-name", conditions = {...}, stateColumnsMapping = {...})',
    ],
    italic: [
      'lookup("constant-attribute-name", conditions = {...}, stateColumnsMapping = {...})',
    ],
    id: 7,
  },
  {
    text: [
      'How Lookup Works:',
      '• System loads the Excel file',
      '• Finds the row where all conditions match',
      '• Reads the current model stage from entityDetail.status',
      '• Picks the template column for that stage',
      '• Returns the cell value',
    ],
    bold: [],
    id: 8,
  },
  {
    text: [
      'Return Values:',
      '• If matching row + column exists → returns the cell value.',
      '• If no row matches → returns "" (empty string).',
      '• If row matches but cell is empty → returns "".',
    ],
    bold: [],
    id: 9,
  },
  {
    text: [
      'How HTML works:',
      '• Use {{attributes.attribute_name}} to access attributes.',
      '• Returned keys from formulas can be directly used inside HTML templates.',
      '• HTML templates support Jinja/Django-style syntax.',
      '• Saved filters can be used to dynamically fetch and render entity data.',
      '• HTML templates support loops (for) and conditional rendering (if/else).',
      '• Inline CSS is recommended for reliable rendering.',
    ],
    bold: ['{{attributes.attribute_name}}'],
    id: 10,
  },
];

export const PAGE_SIZE = 25;
export const TABLE_PAGE_SIZE_OPTIONS = [25, 50, 100];

export const HEALTH_ENABLED_TEMPLATE_TYPES = [
  'ModelInventory',
  'ModelAssociation',
];

export const EMPTY_HEALTH_DEFINITION = {
  label: '',
  formula: '',
  fail_reason: '',
  color: '#000',
};

export const PARAGRAPH_SCHEMA = {
  schema: [
    {
      name: 'title',
      data_type: 'string',
      yup_schema: [
        {
          type: 'required',
          params: ['Field is required'],
        },
        {
          type: 'max',
          params: [200, 'Paragraph heading cannot exceed 200 characters'],
        },
      ],
    },

    {
      name: 'description',
      data_type: 'string',
      yup_schema: [
        {
          type: 'required',
          params: ['Field is required'],
        },
      ],
    },
  ],
};

export const ARRAY_SCHEMA = {
  schema: [
    {
      type: 'min',
      params: [1, 'Attribute Required'],
    },
    {
      type: 'required',
      params: ['This field is required'],
    },
  ],
};

export const HEALTH_EXPRESSION_EXAMPLES = [
  {
    id: 1,
    description: `The expression checks if a model's performance attribute is above 0.9 and its accuracy attribute is above 80.`,
    expression: `{{attributes.performance}} > 0.9 and {{attributes.accuracy}} > 80`,
    title: `Example 1: Simple health definition based on attributes`,
  },
  {
    id: 2,
    description: `This expression calculates the number of "finding template" entities associated with a given entity where the health detail is "LOW". It iterates through the finding template list (accessed via entityAssociation.finding template) and counts those where the nested entityDetail.health attribute is "LOW". Since it's a python expression, we can use len() function to count the number of entities satisfying this condition.`,
    expression: `len([a for a in {{entityAssociation.finding template}} if {{a.entityDetail.health}} == "LOW"]) > 0`,
    title: `Example 2: Health definition based on health of associated entities`,
  },
  {
    id: 3,
    description: `This expression checks if the number of overdue alerts for the entity, represented by entityDetail.overdue_alerts, is greater than 3. It evaluates to true if the entity has more than 3 overdue alerts, and false otherwise.`,
    expression: `{{entityDetail.overdue_alerts}} > 3`,
    title: `Example 3: Health based on number of alerts for the entity`,
  },
  {
    id: 4,
    description: `This expression checks if the number of days a transition is overdue, represented by entityDetail.transition_overdue_days, is greater than 2.`,
    expression: `{{entityDetail.transition_overdue_days}} > 2`,
    title: `Example 4: Health based on number of alerts for the entity (For templates with effort management)`,
  },
];

export const ENTITY_DOCUMENTS_ALLOWED_FILE_EXTENSIONS = {
  PDF: {
    extension: 'pdf',
    mimetype: 'application/pdf',
  },
  DOC: {
    extension: 'doc',
    mimetype: 'application/msword',
  },
  DOCX: {
    extension: 'docx',
    mimetype:
      'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  },
  XLS: {
    extension: 'xls',
    mimetype: 'application/vnd.ms-excel',
  },
  XLSX: {
    extension: 'xlsx',
    mimetype:
      'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  },
  PPT: {
    extension: 'ppt',
    mimetype: 'application/vnd.ms-powerpoint',
  },
  PPTX: {
    extension: 'pptx',
    mimetype:
      'application/vnd.openxmlformats-officedocument.presentationml.presentation',
  },
  CSV: {
    extension: 'csv',
    mimetype: 'text/csv',
  },
  TXT: {
    extension: 'txt',
    mimetype: 'text/plain',
  },
  ZIP: {
    extension: 'zip',
    mimetype: 'application/zip',
  },
  RAR: {
    extension: 'rar',
    mimetype: 'application/vnd.rar',
  },
  R: {
    extension: 'r',
    mimetype: 'text/x-r',
  },
  SAS: {
    extension: 'sas',
    mimetype: 'application/x-sas',
  },
  SAS7BDAT: {
    extension: 'sas7bdat',
    mimetype: 'application/x-sas-data',
  },
  PY: {
    extension: 'py',
    mimetype: 'text/x-python',
  },
  MD: {
    extension: 'md',
    mimetype: 'text/markdown',
  },

  XML: {
    extension: 'xml',
    mimetype: 'application/xml',
  },

  XSD: {
    extension: 'xsd',
    mimetype: 'application/xml',
  },
  XSL: {
    extension: 'xsl',
    mimetype: 'application/xml',
  },
  XSLT: {
    extension: 'xslt',
    mimetype: 'application/xslt+xml',
  },
  JSON: {
    extension: 'json',
    mimetype: 'application/json',
  },
  HTML: {
    extension: 'html',
    mimetype: 'text/html',
  },
  HTM: {
    extension: 'htm',
    mimetype: 'text/html',
  },
  JPG: {
    extension: 'jpg',
    mimetype: 'image/jpeg',
  },
  JPEG: {
    extension: 'jpeg',
    mimetype: 'image/jpeg',
  },
  PNG: {
    extension: 'png',
    mimetype: 'image/png',
  },
  WEBP: {
    extension: 'webp',
    mimetype: 'image/webp',
  },
  SVG: {
    extension: 'svg',
    mimetype: 'image/svg+xml',
  },
  PARQUET: {
    extension: 'parquet',
    mimetype: 'application/vnd.apache.parquet',
  },
  PST: {
    extension: 'pst',
    mimetype: 'application/vnd.ms-outlook',
  },
  EML: {
    extension: 'eml',
    mimetype: 'message/rfc822',
  },
  MSG: {
    extension: 'msg',
    mimetype: 'application/vnd.ms-outlook',
  },
};
export const DOCUMENT_EXTENSION_OPTIONS = [
  { label: 'Pdf', value: 'pdf' },
  { label: 'Doc', value: 'doc' },
  { label: 'Docx', value: 'docx' },
  { label: 'Xls', value: 'xls' },
  { label: 'Xlsx', value: 'xlsx' },
  { label: 'Ppt', value: 'ppt' },
  { label: 'Pptx', value: 'pptx' },
  { label: 'Csv', value: 'csv' },
  { label: 'Txt', value: 'txt' },
  { label: 'Zip', value: 'zip' },
  { label: 'Rar', value: 'rar' },
  { label: 'R', value: 'r' },
  { label: 'Sas7bdat', value: 'sas7bdat' },
  { label: 'Py', value: 'py' },
  { label: 'Xml', value: 'xml' },
  { label: 'Xsd', value: 'xsd' },
  { label: 'Xsl', value: 'xsl' },
  { label: 'Xslt', value: 'xslt' },
  { label: 'Json', value: 'json' },
  { label: 'Html', value: 'html' },
  { label: 'Htm', value: 'htm' },
  { label: 'Jpg', value: 'jpg' },
  { label: 'Jpeg', value: 'jpeg' },
  { label: 'Png', value: 'png' },
  { label: 'WebP Image', value: 'webp' },
  { label: 'SVG Image', value: 'svg' },
  { label: 'Parquet', value: 'parquet' },
  { label: 'Pst', value: 'pst' },
  { label: 'Eml', value: 'eml' },
  { label: 'Msg', value: 'msg' },
  { label: 'Md', value: 'md' },
  { label: 'Python', value: 'py' },
  { label: 'Python Windowed', value: 'pyw' },
  { label: 'Jupyter Notebook', value: 'ipynb' },
  { label: 'Sas', value: 'sas' },
  { label: 'C', value: 'c' },
  { label: 'C++', value: 'cpp' },
  { label: 'C#', value: 'cs' },
  { label: 'Go', value: 'go' },
  { label: 'Java', value: 'java' },
  { label: 'JavaScript', value: 'js' },
  { label: 'TypeScript', value: 'ts' },
  { label: 'Shell Script', value: 'sh' },
  { label: 'CSS', value: 'css' },
  { label: 'WebP Image', value: 'webp' },
  { label: 'SVG Image', value: 'svg' },
  { label: 'OpenDocument Text', value: 'odt' },
  { label: 'XPS Document', value: 'xps' },
  { label: 'Sql', value: 'sql' },
  { label: 'Egp', value: 'egp' },
];

export const ALERT_LABEL = {
  Low: 'No Risk',
  Medium: 'Moderate Risk',
  High: 'High Risk',
};
export const CHECKLIST_TYPES = {
  NORMAL: 'normal',
  SAVE_SEARCH: 'save_search',
};

export const CHECKLIST_DATA_TYPE = 'Checklist';

/** `data_type` value for HTML content attributes (Attribute Library & model forms). */
export const ATTRIBUTE_DATA_TYPE_HTML = 'HTML';

export const EMAIL_TEMPLATE_EDITOR_MODES = {
  TEXT: 'TEXT',
  HTML: 'HTML',
};

export const getDefaultReportTypes = (hideExtraReports = []) => {
  // Note: Read function code before changing anything in this function
  const base = [
    { label: 'Activity Report', value: 'Activity Report', icon: Activity },
    {
      label: `${getLabelPathFromLabelConfig(
        `TEMPLATE_TYPES?.ModelInventory`,
        'featureLabel',
        'Model'
      )} Report`,
      value: 'Model Report',
      icon: ModelReport,
    },
    {
      label: 'Connectivity Report',
      value: 'Connectivity Report',
      icon: Connectivity,
    },
    { label: 'Attribute Report', value: 'Attribute Report', icon: Attribute },
    { label: 'KRI Report', value: 'KRI Report', icon: KRIReport },
    { label: 'PowerBI Report', value: 'PowerBI Report', icon: PowerBI },
  ];

  // filter out reports if their values are present in hideExtraReports array
  if (Array.isArray(hideExtraReports)) {
    return base.filter((report) => !hideExtraReports?.includes(report?.value));
  }

  // NOTE: this is fallback in case hideExtraReports is just boolean true,
  // in that case we will hide last 4 reports from the list
  // coz we are hiding just last three on plugin basis
  return hideExtraReports ? base.slice(0, base.length - 4) : base;
};

export const DMS_MAX_TOTAL_FILE_SIZE = 40000000;
// Max files allowed per single upload action/dropzone batch in DMS
export const DMS_MAX_ALLOWED_FILES_COUNT = 10;
export const MAX_IMAGE_SIZE = 5 * 1024 * 1024; // 5MB
// Max total files allowed across the entire upload panel (may span multiple batches)
export const MAX_UPLOAD_PANEL_FILES_COUNT = 15;

export const HOME_PAGE_SETUP = 'dashboardconfig';

export const EXCLUDED_DATATYPES_IN_FILTER = [
  'Table',
  'AdvancedTable',
  'Checklist',
  'Paragraph',
  'Document',
  'Chart',
  'HTML',
  'Association',
  'IssueType',
];

export const ENTITIES = [
  {
    value: 'Artifact',
    label: 'Sub-Process',
    entityType: 'ModelAssociation',
    requestType: 'Normal',
  },
  {
    value: 'Assessment',
    label: 'Assessment',
    entityType: 'ModelInventory',
    requestType: 'ModelRequest',
  },
  {
    value: 'Use Case',
    label: 'Use Case',
    entityType: 'ModelInventory',
    requestType: 'UseCase',
  },
  {
    value: 'Query',
    label: 'Query',
    entityType: 'ModelInventory',
    requestType: 'Query',
  },
  {
    value: 'Model',
    label: 'Model',
    entityType: 'ModelInventory',
    requestType: 'Normal',
  },
  { value: 'Team', label: 'Role' },
];

export const SHOW_IN_OPTION = ['Dashboard', 'DashboardConfig'];

export const ASSIGNED_TO_ME = 'Assigned to me';

export const ENTITY_TYPE_LOCAL = {
  Models: {
    entityType: 'ModelInventory',
    requestType: 'Normal',
    getLabel: () =>
      getLabelPathFromLabelConfig(
        'TEMPLATE_TYPES.ModelInventory',
        'featureLabel',
        'Model'
      ),
  },
  Artifacts: {
    entityType: 'ModelAssociation',
    requestType: 'Normal',
    getLabel: () =>
      getLabelPathFromLabelConfig(
        'TEMPLATE_TYPES.ModelAssociation',
        'featureLabel',
        'Artifact'
      ),
  },
  Assessment: {
    entityType: 'ModelInventory',
    requestType: 'ModelRequest',
    getLabel: () =>
      getLabelPathFromLabelConfig(
        'TEMPLATE_TYPES.ModelRequest',
        'featureLabel',
        'Assessment'
      ),
  },
  'Use Case': {
    entityType: 'ModelInventory',
    requestType: 'UseCase',
    getLabel: () =>
      getLabelPathFromLabelConfig(
        'TEMPLATE_TYPES.UseCase',
        'featureLabel',
        'Use Case'
      ),
  },
  'Access Request': {
    entityType: 'ModelInventory',
    requestType: 'AccessRequest',
    getLabel: () =>
      getLabelPathFromLabelConfig(
        'TEMPLATE_TYPES.AccessRequest',
        'featureLabel',
        'Access Request'
      ),
  },
  Query: {
    entityType: 'ModelInventory',
    requestType: 'Query',
    getLabel: () =>
      getLabelPathFromLabelConfig(
        'TEMPLATE_TYPES.Query',
        'featureLabel',
        'Query'
      ),
  },
};

export const EXCLUDED_DATA_TYPE_FROM_CONFIGURATION = [
  'chart',
  'document',
  'table',
  'advancedtable',
  'issuetype',
];
export const EXCLUDED_INPUT_CONTROL_TYPE_FROM_CONFIGURATION = ['MULTI_SELECT'];
export const NOOP = () => {};
export const NOOP_PROMISE = () => Promise.resolve({});
export const EMPTY_ARRAY = [];
export const EMPTY_OBJECT = {};

export const DISABLE_DATA_TYPE_FOR_DERIVED = [
  'Paragraph',
  'Checklist',
  'Hyperlink',
];

export const DISABLE_INPUT_TYPE_FOR_DERIVED = ['SINGLE_SELECT', 'MULTI_SELECT'];

export const ENTITY_TYPE_CONFIGURE_ATTRIBUTE = {
  ...ENTITY_TYPES,
  ModelRequest: 'Assessment',
  AccessRequest: 'Access Request',
  UseCase: 'Use Case',
};

export const USERS_WITH_DRAFT = 'users_with_draft';

export const LINKED_ENTITIES = 'linked_entities';

export const INCLUDE_DATA_TYPE_FORM_VALUES_DURING_SEGMENT_CREATION = [
  'Document',
];
export const EXCLUDE_DATA_TYPE_DURING_SEGMENT_CREATION_AND_COPYING = [
  'AdvancedTable',
  'Document',
  'User',
];

export const COLUMNS_WITH_DATE_TIME_FORMAT = ['created_on', 'updated_on'];

/** Returns date format for a column: DATE_FORMAT_HH_MM for created_on/updated_on, else DATE_FORMAT */
export const getDateFormatForColumn = (isCreatedOrUpdatedOn) =>
  isCreatedOrUpdatedOn ? DATE_FORMAT_HH_MM : DATE_FORMAT;

export const INCLUDE_ATTRIBUTES_NAME_FORM_VALUES_DURING_SEGMENT_CREATION = [
  'B14',
];

export const DEFAULT_SEGMENT_ID = '01';

export const SEGMENT_DATA = {
  SEGMENT_NUMBER: 'B1',
  SEGMENT_NAME: 'B2',
};

// Custom event names for session management
export const SESSION_EVENTS = {
  TOKEN_EXPIRED: 'SESSION_TOKEN_EXPIRED',
  SESSION_REFRESHED: 'SESSION_REFRESHED',
  USER_CONFIRMED: 'SESSION_USER_CONFIRMED',
  USER_DECLINED: 'SESSION_USER_DECLINED',
  SESSION_FULLY_EXPIRED: 'SESSION_FULLY_EXPIRED',
  SESSION_LOGOUT_ACKNOWLEDGED: 'SESSION_LOGOUT_ACKNOWLEDGED',
};

export const ENABLE_GROUP_SELECTION_FOR_ROLES = [
  'MRM Admin Group',
  'MRM Oversight FH',
  'MRM Oversight VH',
  'MRM Oversight UH',
  'MRM Oversight TL',
  'MRM Oversight Analyst',
];
export const SORT_BY_OPTION = [
  { label: 'Ascending', value: 'asc' },
  { label: 'Descending', value: 'desc' },
];

export const INCLUDED_DATA_TYPE_FOR_SORT_ORDER = ['Date', 'Character'];

export const QUERY_STATUS_OPTIONS = [
  'Draft',
  'Open',
  'Draft Response',
  'Response Received',
  'In Review',
  'Revision Requested',
  'Waive',
  'Close',
];

export const CRITICALITY_OPTIONS = ['Low', 'Medium', 'High', 'Hardstop'];

export const RAISE_QUERY_OPTIONS = [
  { label: 'Create Query', value: 'Create Query' },
  { label: 'Bulk Action', value: 'Bulk Action' },
];

export const OVERVIEW_TAB_REDIRECTION_KEY = {
  RELATIONSHIPS: 'relationships',
  NEXT_STAGE: 'nextStage',
  PRELIMINARY: 'preliminary',
  DESCRIPTIVE: 'descriptive',
  COPIED_SECTION: 'copiedSection',
  SEGMENTS: 'segments',
  OVERVIEW: 'overview',
};

export const AI_NOTIFICATION_TOAST_STATUS = {
  IN_PROGRESS: 'in_progress',
  COMPLETED: 'completed',
  FAILED: 'failed',
};

export const CHANGE_REQUEST_MAPPING_TYPES = [
  { label: 'Attribute List', value: 'AttributeList' },
  { label: 'Template List', value: 'TemplateList' },
  { label: 'Email Template List', value: 'EmailTemplateList' },
  { label: 'Parameter Table List', value: 'ParameterTableList' },
  { label: 'Configuration Change Type', value: 'ConfigurationChangeType' },
  { label: 'Field Change Type', value: 'FieldChangeType' },
  { label: 'Reason For Field Change', value: 'ReasonForFieldChange' },
  { label: 'Rejection Reason', value: 'RejectionReason' },
];

// These mapping types are used to configure Raise Request when Approval required [Maker Checker]
export const RESTRICTED_MAPPING_TYPES = [
  'RejectionReason',
  'ReasonForFieldChange',
];

export const AI_AUTOFILL_TOAST_STATUS = {
  IN_PROGRESS: 'in_progress',
  COMPLETED: 'completed',
  FAILED: 'failed',
};
